<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">C<span class="small">ONTENTS</span></p>
<p class="toc"><a href="#/Acknowledgements">Acknowledgements</a></p>
<p class="toc"><a href="#/Introduction">Introduction</a></p>
<p class="toc1"><a href="#/Chapter1#C1">1. Parker County Courthouse</a></p>
<p class="toc"><span href="#/Chapter2#C2" title="Link target outside of Sample">2. Angel’s Nest Bed and Breakfast</span></p>
<p class="toc"><span href="#/Chapter3#C3" title="Link target outside of Sample">3. The Davis-Martin Home</span></p>
<p class="toc"><span href="#/Chapter4#C4" title="Link target outside of Sample">4. B and H Feed Store</span></p>
<p class="toc"><span href="#/Chapter5#C5" title="Link target outside of Sample">5. Weatherford Public Library</span></p>
<p class="toc"><span href="#/Chapter6#C6" title="Link target outside of Sample">6. The Baker Mansion</span></p>
<p class="toc"><span href="#/Chapter7#C7" title="Link target outside of Sample">7. Twisted Snifter</span></p>
<p class="toc"><span href="#/Chapter8#C8" title="Link target outside of Sample">8. Apparitions at Chandor Gardens</span></p>
<p class="toc"><span href="#/Chapter9#C9" title="Link target outside of Sample">9. Railroad Ghost Stories</span></p>
<p class="toc"><span href="#/Chapter10#C10" title="Link target outside of Sample">10. 1908 Santa Fe Depot</span></p>
<p class="toc"><span href="#/Chapter11#C11" title="Link target outside of Sample">11. Weatherford Sanitarium</span></p>
<p class="toc"><span href="#/Chapter12#C12" title="Link target outside of Sample">12. Old City Greenwood Cemetery</span></p>
<p class="toc"><span href="#/Chapter13#C13" title="Link target outside of Sample">13. Clark Cemetery</span></p>
<p class="toc"><span href="#/Chapter14#C14" title="Link target outside of Sample">14. Baker Cemetery</span></p>
<p class="toc"><span href="#/Chapter15#C15" title="Link target outside of Sample">15. Spring Creek Cemetery</span></p>
<p class="toc"><span href="#/Chapter16#C16" title="Link target outside of Sample">16. Hoggard-Reynolds Cemetery</span></p>
<p class="toc"><span href="#/Chapter17#C17" title="Link target outside of Sample">17. Oakland Cemetery</span></p>
<p class="toc"><span href="#/Chapter18#C18" title="Link target outside of Sample">18. The Phantom Stagecoach</span></p>
<p class="toc"><span href="#/Chapter19#C19" title="Link target outside of Sample">19. 1869 Mason-Built Weatherford College</span></p>
<p class="toc"><span href="#/Chapter20#C20" title="Link target outside of Sample">20. Campbell Hospital</span></p>
<p class="toc"><span href="#/Chapter21#C21" title="Link target outside of Sample">21. Citizens National Bank</span></p>
<p class="toc"><span href="#/Chapter22#C22" title="Link target outside of Sample">22. Weatherford Vintage Car Museum, Event Center, and Grill</span></p>
<p class="toc"><span href="#/Chapter23#C23" title="Link target outside of Sample">23. Knights of Pythias Lodge</span></p>
<p class="toc"><span href="#/Chapter24#C24" title="Link target outside of Sample">24. Franco-Texan Land Company Building</span></p>
<p class="toc"><span href="#/Chapter25#C25" title="Link target outside of Sample">25. 202 West Oak Street</span></p>
<p class="toc"><span href="#/Chapter26#C26" title="Link target outside of Sample">26. First Monday “Stray Days”</span></p>
<p class="toc"><span href="#/Chapter27#C27" title="Link target outside of Sample">27. The Double Cabin at Holland Lake</span></p>
<p class="toc"><span href="#/Chapter28#C28" title="Link target outside of Sample">28. Haunted Amusement Park</span></p>
<p class="toc"><span href="#/Chapter29#C29" title="Link target outside of Sample">29. Veal’s Station and Cemetery</span></p>
<p class="toc"><span href="#/Chapter30#C30" title="Link target outside of Sample">30. Haunted Hill House</span></p>
<p class="toc1"><span href="#/Afterword" title="Link target outside of Sample">Afterword</span></p>
<p class="toc"><span href="#/Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?3ca62f3c